module.exports = __webpack_public_path__ + "img/product-2-xty.cd368114.png";